import React, { useState, useEffect } from "react";
import Navbar from "../component/Dasboard/Navbar";
import Heading from "../component/Dasboard/Heading";
import Jumbutron from "../component/Transaction/Jumbutron";
import { url } from "../api/api";
import axios from "axios";

const Transaction = () => {
  const [balance, setBalance] = useState([]);

  const totalFinalBalance = balance.reduce((accumulator, transaction) => {
    return accumulator + transaction.finalBalance;
  }, 0);

  const formattedBalance = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(totalFinalBalance);

  console.log(formattedBalance);

  useEffect(() => {
    // Fetch data from backend

    const userid = JSON.parse(localStorage.getItem("userdata"));

    axios
      .get(`${url}/funding/fetchbalance`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userid.token}`,
        },
      })
      .then((response) => {
        setBalance(response.data.balance);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, []);

  return (
    <div className="md:h-[800px]  bg-[radial-gradient(89.62%_213.03%_at_38.75%_80.3%,_#07031C_0%,_#241D4A_30.52%,_#07031C_64.32%)]">
      <Navbar />
      <Heading />
      <Jumbutron totalbalance={formattedBalance} />
    </div>
  );
};

export default Transaction;
